import automationDark from '@/assets/service-cards-animated/dark/automation-ai-dark-animated.svg'
import ppcDark from '@/assets/service-cards-animated/dark/ppc-paid-advertising-dark-animated.svg'
import alacarteDark from '@/assets/service-cards-animated/dark/social-media-a-la-carte-dark-animated.svg'
import subscriptionDark from '@/assets/service-cards-animated/dark/social-media-subscription-dark-animated.svg'
import strategyDark from '@/assets/service-cards-animated/dark/strategy-brand-identity-dark-animated.svg'
import webDark from '@/assets/service-cards-animated/dark/web-digital-platforms-dark-animated.svg'
import automationLight from '@/assets/service-cards-animated/light/automation-ai-light-animated.svg'
import ppcLight from '@/assets/service-cards-animated/light/ppc-paid-advertising-light-animated.svg'
import alacarteLight from '@/assets/service-cards-animated/light/social-media-a-la-carte-light-animated.svg'
import subscriptionLight from '@/assets/service-cards-animated/light/social-media-subscription-light-animated.svg'
import strategyLight from '@/assets/service-cards-animated/light/strategy-brand-identity-light-animated.svg'
import webLight from '@/assets/service-cards-animated/light/web-digital-platforms-light-animated.svg'

/*
 * The walker acting out each service, one animated drawing per theme: the
 * light set is brand blue on white, the dark set a lifted blue that stays
 * visible on the dark card. The animation is CSS inside each SVG, which keeps
 * running when the file is shown through <img>, and each file stops it under
 * prefers-reduced-motion by itself.
 *
 * `themeColor` tints the card's gradient (an HSL triple), kept to deep blues
 * and violets around the brand blue so the six read as one family. Keyed by
 * service id from servicesData.
 */
export const serviceIllustrations: Record<string, { light: string; dark: string; themeColor: string }> = {
  'social-media-subscription': { light: subscriptionLight, dark: subscriptionDark, themeColor: '240 70% 28%' },
  'automation-ai': { light: automationLight, dark: automationDark, themeColor: '255 60% 30%' },
  'web-digital-platforms': { light: webLight, dark: webDark, themeColor: '210 65% 25%' },
  'strategy-brand-identity': { light: strategyLight, dark: strategyDark, themeColor: '225 55% 24%' },
  'social-media-alacarte': { light: alacarteLight, dark: alacarteDark, themeColor: '270 50% 30%' },
  'ppc-advertising': { light: ppcLight, dark: ppcDark, themeColor: '190 60% 22%' },
}
